/* eslint-disable global-require */

export default [
  {
    path: 'maps',
    name: 'maps',
    resource: 'Map',
    roles: ['ROLE_ADMIN'],
    component: require('@/components/layout/view-layout').default,
    routes: [
      {
        path: '',
        name: 'list',
        exact: true,
        component: require('@/views/maps/list').default,
        title: 'map_list_title',
        permissions: {
          Map: ['read:list:me']
        }
      },
      {
        path: '/create',
        name: 'create',
        component: require('@/views/maps/form').default,
        title: 'map_create_title',
        roles: ['ROLE_ADMIN'],
        permissions: {
          Map: ['create']
        }
      },
      {
        path: '/:id',
        name: 'update',
        component: require('@/views/maps/form').default,
        title: 'map_update_title',
        permissions: {
          Map: ['read', 'update']
        }
      }
    ]
  }
];
